import * as Sentry from '@sentry/react'

// Same selection as services/api.ts
const apiUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_STAGING_API_URL
    : process.env.REACT_APP_PRODUCTION_API_URL

Sentry.init({
  dsn: 'https://93b55fb129f56b3150734e49d67ca08b@sentry.konnekt-able.com/49',
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Masked: replays would otherwise record whistleblower reports, names and
    // uploaded evidence onto the Sentry server. Unmask harmless UI with the
    // `sentry-unmask` class if a replay turns out too opaque.
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Requests that carry the `sentry-trace` and `baggage` headers. The backend
  // accepts any request header (CORS_ALLOW_HEADERS = ['*']), so the API gets
  // them too.
  tracePropagationTargets: ['localhost', ...(apiUrl ? [apiUrl] : [])],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Record 10% of all sessions
  replaysOnErrorSampleRate: 1.0, // Record every session that hits an error
})
